export default "__VITE_ASSET__330cda54__"